import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var OnlineShopping = function OnlineShopping(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17H12V19H36V17Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.5622 31.0001H16.4372L13.7622 18.2001L15.7247 17.8001L18.0622 29.0001H29.9372L32.2747 17.8001L34.2372 18.2001L31.5622 31.0001Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.0375 18.4877L25.75 10.7627L27.5 9.78766L31.7875 17.5127L30.0375 18.4877Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.9624 18.4877L16.2124 17.5127L20.4999 9.78766L22.2499 10.7627L17.9624 18.4877Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M46 38H2V4H46V38ZM4 36H44V6H4V36Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 43H15V45H33V43Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M25 37H23V44H25V37Z",
      fill: color
    })]
  });
};
export default OnlineShopping;